<template>
	<v-content-layout :noCard="false">
		<template #header>
			<v-btn depressed color="primary" v-tooltip.right="'Only used for Invoice Template Type'"
			@click="downloadFile('invoice_template.xlsx','https://invoice-audit.s3.amazonaws.com/templates/invoice_template.xlsx')"
			>Download Template</v-btn>
		</template>
		
		<template #body-nocard>
			<v-card outlined width="700">
				<v-card-text class="px-5">
					<v-form ref="form" v-model="validUpload" lazy-validation>
						<v-autocomplete
							v-model="formData.uploadType"
							:items="uploadTypes"
							item-text="name"
							item-value="value"
							:rules="[(v) => !!v || 'Upload Type is required']"
							label="Upload Type"
							clearable
							@change="handleUploadType"
						></v-autocomplete>
						<v-text-field
							v-if="!selectInvoice"
							v-model="formData.brandName"
							:rules="[(v) => !!v || 'Brand is required']"
							label="Brand"
							clearable
							persistent-hint
							:hint="brandHint"
						></v-text-field>
						<v-autocomplete
							v-if="selectInvoice"
							v-model="formData.brandName"
							:items="['Grundens']"
							:rules="[(v) => !!v || 'Upload Type is required']"
							label="Brand"
							clearable
						></v-autocomplete>
						<v-autocomplete
							v-if="selectInvoice"
							v-model="formData.invoiceType"
							:items="['MFN', 'BULK']"
							:rules="[(v) => !!v || 'Invoice Type is required']"
							label="Invoice Type"
							clearable
							persistent-hint
							hint="Note: Only applicable for Invoice Upload"
						></v-autocomplete>
						<v-file-input
							v-model="files"
							accept=".xlsx"
							label="Upload File (.xlsx format)"
							@change="uploadFile"
							:show-size="true"
							:loading="loadingUpload"
						></v-file-input>
					</v-form>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions class="px-5">
					<v-btn class="px-5" depressed color="error" outlined @click.stop="clearForm">Clear</v-btn>
					<v-spacer></v-spacer>
					<v-btn
						depressed
						color="primary"
						class="px-5"
						:disabled="disabledSubmit"
						:loading="loadingSubmit"
						@click="submitForm"
					>Submit</v-btn>
				</v-card-actions>
			</v-card>
		</template>
	</v-content-layout>
</template>

<script>
import downloadFile from '@/services/downloadFileSvc';
import { updateStoredListStatus } from '@/services/fileHandlerSvc'
import { state, getters } from '@/store/store';
export default {
	data: () => ({
		selectInvoice: true,
		validUpload: true,
		uploadTypes: [
			{ name: 'via Raw Invoice (for parsing)', value: 'default' },
			// { name: 'via Invoice Template', value: 'fileFeed' }
		],
		formData: {
			batchID: '',
			user: '',
			uploadType: '',
			brandName: '',
			invoiceType: '',
			fileName: '',
		},
		files: [],
		disabledSubmit: true,
		loadingSubmit: false,
		loadingUpload: false,
	}),
	computed: {
		...getters, //getCurrentUser
		brandHint(){
			return !this.selectInvoice ? 'Enter "Mix Brands" if you have more than one brand in the template.' : 'Please enter valid brand.'
		}
	},
	methods: {
		downloadFile,
		async uploadFile() {
			if (this.files) {
				if(this.formData.uploadType === 'default'){
					try {
						this.loadingUpload = true;
						let formData = new FormData();
						formData.append('myFile', this.files);
						let response = await this.$http.post('/file/upload', formData, {
							headers: {
								'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
							}
						});
						if (response.status == 200) {
							this.$toast.open({
								message: response.data.msg,
								type: 'success',
							});
							this.disabledSubmit = false;
							this.formData.fileName = response.data.filename;
						}
						this.loadingUpload = false;
					} catch (error) {
						this.$toast.open({
							message: error.data,
							type: 'error',
						});
						this.disabledSubmit = true;
					}
				}else{
					this.disabledSubmit = false;
				}
			} else {
				this.disabledSubmit = true;
			}
		},
		async submitForm() {
			if (this.$refs.form.validate()) {
				this.disabledSubmit = true;
				this.loadingSubmit = true;
				this.$Progress.start();
				if (this.formData.uploadType === 'default') {
					try {
						let response = await this.$http.post('/parse/invoice', JSON.stringify({
							batchId: `IA${Date.now()}`,
							user: this.getCurrentUser,
							type: this.formData.invoiceType,
							brandName: this.formData.brandName,
							fileName: this.formData.fileName,
						}));
						
						if (response.status === 200) {
							
							let currentId = response.data.insertToDb[0].id
							await updateStoredListStatus(currentId, 1)
							this.$Progress.finish();
							this.disabledSubmit = false;
							this.loadingSubmit = false;
							this.$refs.form.reset();

							let batchId = response.data.insertToDb[0].batch_id;
							let invoiceType = response.data.insertToDb[0].invoice_type;
							let invoiceInformation = response.data.invoiceInformation;
							state.parsedResults = {...response.data, invoiceType, invoiceInformation };
							this.$router.push(`/upload-result?batchId=${batchId}&timestamp=${Date.now()}`);
						}
					} catch (error) {
						this.disabledSubmit = false;
						this.loadingSubmit = false;
						this.$Progress.fail();
						this.$toast.open({
							message: error.data.err.msg,
							type: 'error',
						});
					}
				} else {
					try {
						this.loadingUpload = true;
						let batchId = `IA${Date.now()}`;
						let formData = new FormData();
						formData.append('myFile', this.files);
						formData.append('brandName', `${this.formData.brandName}`);
						formData.append('typeOfRequest','fileFeed');
						formData.append('batchId', batchId);
					

						let response = await this.$http.post('/file/upload', formData, {
							headers: {
								'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
							}
						});
						if(response.status === 200){
							
							let response2 = await this.$http.post('/feed/invoice', JSON.stringify({
								typeOfRequest: 'fileFeed',
								fileName: response.data.insertToDb[0].file_name
							}))
							
							if(response2.status === 200){
								this.$Progress.finish();
								this.$router.push({path: '/upload-list', query: { batchId }})
							}
						}
					} catch (error) {
						this.disabledSubmit = false;
						this.loadingSubmit = false
						this.loadingUpload = false;
						this.$Progress.fail();
						this.$toast.open({
							message: error.data.err.msg,
							type: 'error',
						});
					}
				}
			}
		},
		clearForm() {
			this.files = [];
			this.selectInvoice = true;
			this.$refs.form.reset();
			this.disabledSubmit = true;
		},
		handleUploadType(value) {
			if (value === 'default') {
				this.selectInvoice = true;
			} else {
				this.selectInvoice = false;
			}
		},
	},
};
</script>
